import axios from 'axios'
import store from '../store'

// Request interceptor
axios.defaults.baseURL = process.env.VUE_APP_API_URL + process.env.VUE_APP_API_VERSION

axios.interceptors.request.use(request => {
	const token = store.getters['auth/getField']('token')

	if (token) {
		request.headers.common['Authorization'] = `Bearer ` + token
	}

	return request
})

axios.interceptors.response.use(response => response, error => {
	const { status } = error.response

	if (status >= 500) {

	}

	if (status === 401 && store.getters.getLoggedInState) {

	}

	return Promise.reject(error)
})
